"use client"

import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded"
import { Badge, Box, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { usePathname } from "next/navigation"
import { HamburgerMenu } from "@refinedev/mui"

const routeMeta: Array<{ match: RegExp; title: string; description: string }> = [
  { match: /^\/dashboard\/customers/, title: "客户中心", description: "沉淀客户档案、偏好与历史关系" },
  { match: /^\/dashboard\/inquiries/, title: "询单中心", description: "承接询单、响应时效与需求澄清" },
  { match: /^\/dashboard\/quotations/, title: "方案与报价", description: "形成定制方案、报价版本与审批依据" },
  { match: /^\/dashboard\/orders/, title: "订单执行", description: "锁定资源、推进交付并追踪异常" },
  { match: /^\/dashboard\/operations\/content/, title: "内容管线", description: "选题、草稿、审核、发布与数据回收的全链路管控" },
  { match: /^\/dashboard\/operations\/accounts/, title: "账号数据", description: "渠道账号矩阵的健康度与作业漏斗" },
  { match: /^\/dashboard\/operations\/resources/, title: "计调资源", description: "沉淀目的地资源与通用资源，支撑询单记录、行程方案和供应链作业" },
  { match: /^\/dashboard\/suppliers/, title: "供应链中心", description: "管理供应商档案与资源协作" },
  { match: /^\/dashboard\/finance/, title: "财务中心", description: "应收应付、回款结算与对公账户" },
  { match: /^\/dashboard\/approvals/, title: "审批中心", description: "聚合高风险、高金额与退款审批" },
  { match: /^\/dashboard\/files/, title: "文件中心", description: "统一沉淀附件、合同、行程与资料文件" },
  { match: /^\/dashboard\/playbooks/, title: "定制师手册", description: "定制师从入职到独立上岗的全链路作训与考核" },
  { match: /^\/dashboard\/insights/, title: "认知库", description: "行业洞见、战略解读与方法论沉淀" },
  { match: /^\/dashboard\/toolbox/, title: "工具箱", description: "汇率、报价核算与出境常用查询" },
  { match: /^\/dashboard\/users/, title: "用户管理", description: "管理员工账号、角色分配与账号状态" },
  { match: /^\/dashboard\/org/, title: "组织与权限", description: "管理部门结构、负责人和权限边界" },
  { match: /^\/dashboard\/settings/, title: "系统参数", description: "全系统基础设置入口，集中维护口径、规则与模板" },
  { match: /^\/dashboard\/profile/, title: "个人设置", description: "维护个人资料、账号信息与后续偏好设置" },
  { match: /^\/dashboard$/, title: "经营总览", description: "查看询单转化、签单回款与当前风险点" },
]

function getRouteMeta(pathname: string) {
  return routeMeta.find((item) => item.match.test(pathname)) ?? routeMeta[routeMeta.length - 1]
}

export function AppHeader() {
  const pathname = usePathname()
  const current = getRouteMeta(pathname)

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        backdropFilter: "blur(14px)",
        background: "rgba(245,247,251,0.82)",
        borderBottom: "1px solid rgba(15,23,42,0.08)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ minHeight: 64, px: { xs: 2, md: 3 } }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <HamburgerMenu />
          <Box>
            <Typography sx={{ fontSize: 15, fontWeight: 700, color: "text.primary" }}>
              {current.title}
            </Typography>
            <Typography sx={{ mt: 0.2, fontSize: 12, color: "text.secondary" }}>
              {current.description}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={0.75} alignItems="center">
          <Tooltip title="搜索" arrow>
            <IconButton
              size="small"
              sx={{
                width: 34,
                height: 34,
                border: "1px solid rgba(15,23,42,0.08)",
                background: "rgba(255,255,255,0.72)",
              }}
            >
              <SearchRoundedIcon sx={{ fontSize: 18, color: "rgba(15,23,42,0.72)" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="消息" arrow>
            <IconButton
              size="small"
              sx={{
                width: 34,
                height: 34,
                border: "1px solid rgba(15,23,42,0.08)",
                background: "rgba(255,255,255,0.72)",
              }}
            >
              <Badge
                color="primary"
                variant="dot"
                overlap="circular"
                sx={{
                  "& .MuiBadge-badge": {
                    width: 7,
                    height: 7,
                    minWidth: 7,
                    borderRadius: "50%",
                    boxShadow: "0 0 0 2px #f5f7fb",
                  },
                }}
              >
                <NotificationsNoneRoundedIcon sx={{ fontSize: 18, color: "rgba(15,23,42,0.72)" }} />
              </Badge>
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
    </Box>
  )
}
